<template>
	<div class="app-text-area">
		<v-textarea v-bind="$attrs" v-on="$listeners" single-line solo flat hide-details>
			<template v-for="(_, slot) of $scopedSlots" v-slot:[slot]="scope"><slot :name="slot" v-bind="scope" /></template>
		</v-textarea>
	</div>
</template>

<script>
export default {
	name: 'AppTextArea',
	props: {},
};
</script>

<style scoped lang="scss">
.app-text-field {
}
</style>
